'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var CustomPopup = require('components/devices/templates/map/custom_popup');
var ExtContent = require('components/devices/templates/map/extension_content');
var FullScreen = require('components/common/behaviors/fullscreen');
var i18n = require('utils/i18n');
var Log = require('utils/log');
var MapFilterView = require('components/devices/views/map/map_filter_view');
var MapToolbarView = require('components/devices/views/map/map_toolbar_view');
var Marker = require('components/devices/templates/map/marker');
var MarkerContent = require('components/devices/templates/map/marker_content');
var Misc = require('utils/misc');
var Notification = require('utils/notification');

var MapView = Marionette.LayoutView.extend({
    template: require('components/devices/templates/map/map'),

    controller: undefined,
    heatmapData: undefined,

    defaults: {
        max_zoom_cluster: 14,
        max_nr_subdevices: 5,
        min_zoom: 14,
    },

    layerConfig: {
        max_zoom_cluster: 14,
        max_nr_subdevices: 5,
        min_zoom: 14,
        available: {},
    },

    ui: {
        map: '#map',
    },

    regions: {
        filter: 'div.filter-wrapper',
        toolbar: 'div.map-toolbar',
    },

    events: {
        'hide.bs.select select#js-extension-selector': 'selectExtension',
        'click #js-extension-refresh': 'refreshMap',
        'click .js-edit-filter': 'showFilter',
        'click .js-reset-filter': 'resetFilter',
    },

    behaviors: {
        fullscreen: {
            behaviorClass: FullScreen,
            onEnterFullscreen: function () {
                $('.card-box').addClass('card-box-backup');
                $('.card-box').removeClass('card-box');
            },
            onLeaveFullscreen: function () {
                $('.card-box-backup').addClass('card-box');
                $('.card-box-backup').removeClass('card-box-backup');
            },
        },
    },

    showToolbarView: function () {
        this.showChildView('toolbar', this.toolbar);
    },

    showFilterView: function () {
        this.showChildView('filter', new MapFilterView({ filter: this.filterObj }));

        // currently in full screen mode? -> hide elements
        if (AppState.isFullScreen) {
            $('.js-hide-on-fullscreen').hide();
        }
    },

    initialize: function (options) {
        this.options = options;
        this.controller = options.controller;

        var paramsFromURL = AppState.getURLParameter();

        this.initialView = options.initialView || { pos: paramsFromURL.pos };

        this.toolbar = new MapToolbarView({
            mapView: this,
            config: paramsFromURL,
        });

        this.field_select = paramsFromURL.addr;

        this.isAutoRefresh = paramsFromURL.autoRefresh == 'true';
        this.isHeatmapShown = paramsFromURL.heatmap == 'true';
        this.isLabelsShown = paramsFromURL.labels == 'true';
        this.isIconsShown = paramsFromURL.icons == undefined || paramsFromURL.icons == 'true';
        this.filterObj = (paramsFromURL.filter && JSON.parse(paramsFromURL.filter)) || AppState.getMapConfig();

        function isFieldValid(item) {
            if (
                Misc.countWhere(Consts.FieldInfo.NoFilter, function (x) {
                    return x == item.id;
                })
            ) {
                return false;
            }
            return item.unit != 'Uhr' && item.format != 't##.##.';
        }

        this.fields = Misc.selectWhere(AppState.uniqueFields(undefined, Consts.FieldGroup.Data), function (item) {
            return isFieldValid(item);
        });
        this.fields.unshift({ id: '--', name: '--' });
    },

    updateFilter: function (filter) {
        this.filterObj = filter;

        AppState.setURLParameter({ filter: JSON.stringify(this.filterObj) }, 'update');
        AppState.saveMapConfig(this.filterObj);

        this.refreshMap();
        this.showFilterView();
        this.toolbar.render();
    },

    resetFilter: function (e) {
        e.preventDefault();
        e.stopPropagation();

        this.updateFilter({});
    },

    showFilter: function (e) {
        var self = this;
        e.preventDefault();
        e.stopPropagation();
        this.filterObj = this.filterObj || {};
        this.options.controller.showFilterDialog(
            this.filterObj,
            function (filter) {
                App.hideModal();
                self.updateFilter(filter);
            },
            false,
            false,
            true
        );
    },

    initializeMap: function () {
        var self = this;

        // creata map layer
        var osmLayer = L.maplibreGL({
            style: '/api/v1/maps/base/style',
            attribution:
                'Esri, HERE, Garmin, FAO, NOAA, USGS, © OpenStreetMap contributors, and the GIS User Community',
        });
        var satelliteLayer = L.maplibreGL({
            style: '/api/v1/maps/satellite/style',
            attribution: 'Esri, Maxar, Earthstar Geographics, and the GIS User Community',
        });

        this.baseMapLayers = {};
        this.baseMapLayers[i18n.TR('Straßenansicht')] = osmLayer;
        this.baseMapLayers[i18n.TR('Luftbild')] = satelliteLayer;

        /*
		// create open streetmap layer
		var osmLayer = new L.TileLayer(
			'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			{
				detectRetina:  false,
				maxNativeZoom: 18,
				attribution:   'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
				drawControl:   true,
			}
		);
*/

        this.pruneCluster = new PruneClusterForLeaflet();

        // set marker utility function
        var colors = ['#777777', '#81C868', '#FFCC33', '#F05050'];
        var pi2 = Math.PI * 2;

        L.Icon.MarkerCluster = L.Icon.extend({
            options: {
                iconSize: new L.Point(44, 44),
                className: 'prunecluster leaflet-markercluster-icon',
            },

            createIcon: function () {
                var e = document.createElement('canvas');

                this._setIconStyles(e, 'icon');
                var s = this.options.iconSize;

                e.width = s.x;
                e.height = s.y;

                this.draw(e.getContext('2d'), s.x, s.y);

                return e;
            },

            createShadow: function () {
                return null;
            },

            draw: function (canvas, width, height) {
                var start = 0;

                for (var i = 0, l = colors.length; i < l; ++i) {
                    var size = this.stats[i] / this.population;
                    if (size > 0) {
                        canvas.beginPath();
                        canvas.moveTo(22, 22);
                        canvas.fillStyle = colors[i];
                        var from = start + 0.14,
                            to = start + size * pi2;
                        if (to < from) {
                            from = start;
                        }
                        canvas.arc(22, 22, 22, from, to);
                        start = start + size * pi2;
                        canvas.lineTo(22, 22);
                        canvas.fill();
                        canvas.closePath();
                    }
                }
                canvas.shadowBlur = 8;
                canvas.shadowColor = '#000';
                canvas.beginPath();
                canvas.fillStyle = '#FFF';
                canvas.arc(22, 22, 18, 0, Math.PI * 2);
                canvas.fill();
                canvas.closePath();

                canvas.shadowBlur = 0;
                canvas.fillStyle = '#555';
                canvas.textAlign = 'center';
                canvas.textBaseline = 'middle';
                canvas.font = 'bold 12px sans-serif';
                canvas.fillText(this.population, 22, 22, 40);
            },
        });

        this.pruneCluster.BuildLeafletClusterIcon = function (cluster) {
            var clusterIcon = new L.Icon.MarkerCluster();

            clusterIcon.stats = cluster.stats;
            clusterIcon.population = cluster.population;

            return clusterIcon;
        };

        // create map view
        this.map = L.map('map', {
            zoomControl: false,
            minZoom: 4,
            maxZoom: 20,
        });
        this.map.addLayer(osmLayer);
        this.map.addLayer(this.pruneCluster);

        // initialize base layer control element
        this.layerControl = L.control.layers(this.baseMapLayers, undefined);
        this.layerControl.addTo(this.map);

        this.initializeCustomization();
        this.initializeDrawingToolbar();
        this.initializePopupHandler();

        var bounds = this.initializeMarker(this.options.devices.models, this.initialView);

        // ---- HEATMAP -------------------------------------------------------
        var cfg = {
            // radius should be small ONLY if scaleRadius is true (or small radius is intended)
            // if scaleRadius is false it will be the constant radius used in pixels
            radius: 40,
            maxOpacity: 0.8,
            // scales the radius based on map zoom
            scaleRadius: false,
            // if set to false the heatmap uses the global maximum for colorization
            // if activated: uses the data maximum within the current map boundaries
            //   (there will always be a red spot with useLocalExtremas true)
            useLocalExtrema: false,
            // which field name in your data represents the latitude - default "lat"
            latField: 'lat',
            // which field name in your data represents the longitude - default "lng"
            lngField: 'lng',
            // which field name in your data represents the data value - default "value"
            valueField: 'value',
        };

        this.heatmapLayer = new HeatmapOverlay(cfg);
        // --------------------------------------------------------------------

        // set initial view
        this.map.fitBounds(bounds.get());

        // initialize resize handler
        window.mapResizeHandler = function (bounds) {
            if (self.ui.isDestroyed) {
                return;
            }

            var h = window.innerHeight - (AppState.isFullScreen ? 100 : 330); // trial and error
            h = Math.max(h, 400);

            self.ui.map.css('height', h + 'px');
            self.mapRefresh();

            if (bounds) {
                self.map.fitBounds(bounds.get());
            }
        };
        window.resizefunc.push('mapResizeHandler');

        // initialize container
        window.mapResizeHandler(bounds);

        // initialize map auto-refresh
        this.initializeRefreshTimer();
        this.refreshMap();
    },

    saveMapStateInURL: function () {
        // check if view is still active
        if (this.isDestroyed || (AppState.route && AppState.route.substring(0, 3) != 'map')) {
            return;
        }

        AppState.setURLParameter(
            {
                pos: this.map.getBounds().toBBoxString(),

                addr: this.field_select,

                autoRefresh: this.toolbar.isAutoRefresh,
                heatmap: this.toolbar.isHeatmapShown,
                labels: this.toolbar.isLabelsShown,
                icons: this.toolbar.isIconsShown,

                filter: this.filterObj && JSON.stringify(this.filterObj),
            },
            'replace'
        );
    },

    mapRefresh: function (isPart) {
        this.map.invalidateSize();
        if (!isPart) {
            this.map._resetView(this.map.getCenter(), this.map.getZoom(), true);
        }
        this.pruneCluster.ProcessView();

        if (this.toolbar.isHeatmapShown) {
            this.map.addLayer(this.heatmapLayer);
        } else {
            this.map.removeLayer(this.heatmapLayer);
        }
        this.heatmapLayer.setData(this.heatmapData);

        this.saveMapStateInURL();
    },

    isSelected: function (status) {
        var statusSelection = (this.filterObj || {}).status;
        var convertedStatus = Misc.convertValue(status, Consts.DeviceStatus, Consts.DeviceStatusURL, status);

        return !statusSelection || _.indexOf(statusSelection, convertedStatus) != -1;
    },

    initializeMarker: function (devices, initialView, noClearHeatmap) {
        var self = this;

        var CustomMarker = L.Icon.Default.extend({
            options: L.Icon.Default.prototype.options,
        });

        var setMarker = function (text, style, pos, device) {
            // create marker
            var marker = new PruneCluster.Marker(pos[1], pos[0]);

            // initialize marker properties
            var status = device !== undefined ? device.get('status') : -2;
            switch (status) {
                case -4: {
                    marker.category = 0;
                    break;
                } // archived
                case -3: {
                    marker.category = 0;
                    break;
                } // deactivated / unknown
                case -2: {
                    marker.category = 0;
                    break;
                } // unknown
                case 0: {
                    marker.category = 1;
                    break;
                } // ok
                case -1: {
                    marker.category = 3;
                    break;
                } // delayed
                default: {
                    marker.category = 2;
                    break;
                } // any error
            }

            if (!self.isSelected(status)) {
                // excluded by filter
                return;
            }

            // format value
            if (typeof device.attributes.data == 'number') {
                var selected = self.toolbar.selectedField();
                if (self.extensionConf && self.extensionConf.activePlugin) {
                    selected = self.extensionConf.activePlugin.addr;
                }

                if (selected) {
                    var valueInfo = Misc.formatValueUnit(
                        device.attributes.data,
                        selected,
                        AppState.uniqueColumns(),
                        false,
                        device.get('formatInfos')
                    );
                    device.attributes.data_formatted = valueInfo.value + ' ' + valueInfo.unit;
                }
            }

            // initialize marker popup
            var popupContext = {
                text: text,
                device: device,
                link: '',
            };

            if (device !== undefined) {
                popupContext['device'] = device.attributes;
                popupContext['link'] = Misc.getDeviceURL(device.get('category'), device.id);
            }

            marker.data.id = device.id;
            marker.data.popup = Marker(popupContext);

            // initialize marker icon
            var deviceTypeIcon = '';
            var iconSize = undefined;
            var shadowAnchor = undefined;

            // .. determine marker icon file

            // TODO: always try to use <category>-<type>, auto-fallback to default

            var category = device !== undefined ? device.get('category').toLowerCase() : '';
            var type = device !== undefined ? device.get('type').toLowerCase() : '';

            if (type.startsWith('ext_')) {
                type = '';
            } else {
                switch (category) {
                    case 'gateway':
                    case 'gateway-rf':
                        deviceTypeIcon = type + '-';
                        break;
                    case '55xx56xx':
                        deviceTypeIcon = '55xx56xx-';
                        break;
                    case 'actuator':
                        deviceTypeIcon = 'actuator-';
                        break;
                    case 'genericmodbus':
                        if (type == '3374' || type == '6611') {
                            deviceTypeIcon = 'genericmodbus-' + type + '-';
                        } else {
                            // default icon
                            deviceTypeIcon = 'genericmodbus-6611-';
                        }
                        break;
                    case 'meter':
                        deviceTypeIcon = 'meter-wmz-';
                        break;
                }
            }

            // .. initialize map icon
            if (deviceTypeIcon != '') {
                iconSize = [31, 41];
                shadowAnchor = [8, 41];
            }
            var iconBase = 'marker-icon-' + deviceTypeIcon + marker.category;

            if (self.toolbar.isLabelsShown) {
                if (device.attributes.data_formatted) {
                    // text label with data
                    marker.data.icon = L.divIcon({
                        className: 'map-info',
                        iconSize: null,
                        html: '<div class="map-value-marker">' + device.attributes.data_formatted + '</div>',
                    });
                }
            } else {
                // default map marker
                marker.data.icon = new CustomMarker({
                    iconUrl: iconBase + '.png',
                    iconRetinaUrl: iconBase + '-2x.png',
                    shadowUrl: 'marker-shadow.png',

                    iconSize: iconSize,
                    shadowAnchor: shadowAnchor,
                });
            }

            if (typeof device.attributes.data == 'number') {
                var dataValue = device.attributes.data;

                self.heatmapData.min = Math.min(self.heatmapData.min, dataValue);
                self.heatmapData.max = Math.max(self.heatmapData.max, dataValue);
                self.heatmapData.data.push({ lat: pos[1], lng: pos[0], value: dataValue });
            }

            if (self.extensionConf && self.extensionConf.activePlugin) {
                marker = window.map_extension.element(self.extensionConf.activePlugin.id, {
                    marker: marker,
                    device: device,
                    input: $('#js-extension-input').val(),
                });
            }

            // save marker
            if (marker !== undefined && self.toolbar.isIconsShown) {
                self.pruneCluster.RegisterMarker(marker);
            }
            return marker;
        };

        var minLat = self.options.bounds.lat.min || 47.3024876979;
        var maxLat = self.options.bounds.lat.max || 54.983104153;
        var minLng = self.options.bounds.lng.min || 5.98865807458;
        var maxLng = self.options.bounds.lng.max || 15.0169958839;

        var initialMapBounds = undefined;
        var bounds = {
            count: 0,
            // default: use Germany bounding box
            min: { lat: minLat, lng: minLng },
            max: { lat: maxLat, lng: maxLng },

            addPoint: function (pos) {
                if (this.count == 0) {
                    this.min = { lat: pos[1], lng: pos[0] };
                    this.max = { lat: pos[1], lng: pos[0] };
                } else {
                    this.min.lat = Math.min(this.min.lat, pos[1]);
                    this.min.lng = Math.min(this.min.lng, pos[0]);
                    this.max.lat = Math.max(this.max.lat, pos[1]);
                    this.max.lng = Math.max(this.max.lng, pos[0]);
                }
                this.count += 1;
            },

            get: function () {
                return new L.LatLngBounds(
                    { lat: this.min.lat - 0.001, lng: this.min.lng - 0.001 },
                    { lat: this.max.lat + 0.001, lng: this.max.lng + 0.001 }
                );
            },
        };

        // pre-defined view? -> initialize bounds
        if (!initialView.preProcessed && initialView.pos !== undefined) {
            initialView.pos = initialView.pos.split(',');
            initialMapBounds = {
                get: function () {
                    return new L.LatLngBounds(
                        { lat: initialView.pos[1], lng: initialView.pos[0] },
                        { lat: initialView.pos[3], lng: initialView.pos[2] }
                    );
                },
            };
        }
        if (!initialView.preProcessed && initialView.location !== undefined) {
            initialView.location = initialView.location.replace(/\[|\]/gi, '').split(',');
            initialMapBounds = {
                get: function () {
                    return new L.LatLngBounds(
                        { lat: initialView.location[1], lng: initialView.location[0] },
                        { lat: initialView.location[1], lng: initialView.location[0] }
                    );
                },
            };
        }
        initialView.preProcessed = true;

        // clear heat map data
        if (!noClearHeatmap) {
            self.heatmapData = { min: 0, max: 0, data: [] };
        }

        // show devices on map
        _.each(devices, function (d) {
            var location = d.get('location');
            if (location != '') {
                // create marker
                var pos = JSON.parse(location);
                var marker = setMarker(d.get('name'), 'primary', pos, d);

                if (marker !== undefined) {
                    // update bounding box
                    bounds.addPoint(pos);
                    // initialize popup
                    if (self.initialPopup === undefined && d.id === initialView.id) {
                        self.initialPopup = L.popup().setLatLng([pos[1], pos[0]]).setContent(marker.data.popup);
                    }
                }
            }
        });

        self.initialMapBounds = bounds.get();
        return initialMapBounds ? initialMapBounds : bounds;
    },

    refreshMap: function (e, withoutFeedback) {
        if (e != undefined) {
            e.preventDefault();
        }

        this.isRefreshing = true;

        var deviceListParams = {
            filterParams: {
                bbox: this.map.getBounds().toBBoxString(),
                filter: this.filterObj,
            },
            addr: this.toolbar.selectedField(),
        };

        if (this.extensionConf && this.extensionConf.activePlugin) {
            // adapt to extension requirements
            deviceListParams.filterParams = this.extensionConf.activePlugin.filter || deviceListParams.filterParams;
            deviceListParams.addr = this.extensionConf.activePlugin.addr;
        }

        if (!AppState.featureBBoxMapReload) {
            deviceListParams.filterParams.bbox = '';
        }

        var self = this;
        var baseParams = deviceListParams;
        var readBatch = function (page) {
            deviceListParams = $.extend({}, baseParams);
            $.extend(deviceListParams.filterParams, { sort: 'id', limit: 1000, page: page });

            self.toolbar.indicateRefresh(true);

            var devices = App.request('device:list:geo', deviceListParams);
            $.when(devices).done(function (devices) {
                if (devices == undefined) {
                    if (!withoutFeedback) {
                        Notification.show(
                            'error',
                            i18n.TR('Fehler'),
                            i18n.TR('Daten konnten nicht aktualisiert werden.')
                        );
                    }
                    self.isRefreshing = false;
                    self.toolbar.indicateRefresh(false);
                    return;
                }

                // re-initialize marker
                if (page == 0) {
                    self.pruneCluster.RemoveMarkers();
                }
                self.isRefreshing = false;

                if (devices.items.models.length > 0) {
                    self.initializeMarker(devices.items.models, self.initialView, page > 1);
                }

                self.mapRefresh(true);

                if (devices.items.models.length > 0) {
                    readBatch(page + 1);
                } else {
                    self.isRefreshing = false;
                    self.toolbar.indicateRefresh(false);

                    if (self.initialPopup !== undefined) {
                        self.initialPopup.openOn(self.map);
                    }
                    // do not consider intial view when refreshing after first load
                    self.initialView = {};
                    self.initialPopup = undefined;

                    if (!withoutFeedback) {
                        Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Daten aktualisiert.'), 1000);
                    }
                }
            });
        };

        self.pruneCluster.RemoveMarkers();
        readBatch(1);
    },

    updateLayerControlStyling: function (layers) {
        _.each(this.layerConfig.available, function (l) {
            if (!l.options.style) {
                return;
            }

            $('.leaflet-control-layers-overlays span:contains("' + l.name + '")').css(
                'color',
                l.options.style.fillColor || l.options.style.color
            );
        });
    },

    updateLayerControlVisibility: function () {
        var self = this;

        // add/remove custom overlays (if available)
        if (self.customLayerInitialized !== true && self.map.getZoom() >= self.layerConfig.min_zoom) {
            _.each(self.layerConfig.available, function (l) {
                self.layerControl.addOverlay(l, l.name);
            });

            // restore configuration state
            _.each(self.enabledLayers, function (l) {
                self.map.addLayer(l);
            });

            self.customLayerInitialized = true;
            self.updateLayerControlStyling();
        }

        if (self.customLayerInitialized === true && self.map.getZoom() < self.layerConfig.min_zoom) {
            _.each(self.layerConfig.available, function (l) {
                self.layerControl.removeLayer(l);
            });

            // save configuration state
            self.enabledLayers = [];
            _.each(self.customLayers, function (l) {
                if (self.map.hasLayer(l)) {
                    self.enabledLayers.push(l);
                    self.map.removeLayer(l);
                }
            });

            self.customLayerInitialized = false;
        }
    },

    toggleAutoRefresh: function () {
        this.refreshMap(undefined, true);
        this.initializeRefreshTimer();
    },

    initializeRefreshTimer: function () {
        if (!this.toolbar.isAutoRefresh) {
            return;
        }

        var self = this;
        setTimeout(function () {
            self.refreshMap(undefined, true);
            self.initializeRefreshTimer();
        }, 20000);
    },

    initializeExtensionUI: function () {
        // re-initialize extension
        $('#extension').empty();
        $('#extension').html(ExtContent(this.extensionConf));
        Misc.initSelectPicker({
            selector: '#js-extension-selector',
            dropupAuto: false,
        });

        if (typeof window.map_extension.init === 'function') {
            // initialize map extension plugin
            window.map_extension.init(this.extensionConf.activePlugin ? this.extensionConf.activePlugin.id : -1);
        }
    },

    selectExtension: function (e) {
        var selected = parseInt(e.target.value);

        if (selected == this.extensionConf.activeID) {
            // already active -> do nothing
            return;
        }

        // re-initialize
        this.extensionConf.activeID = selected;
        this.extensionConf.activePlugin = selected == -1 ? undefined : this.extensionConf.plugins[selected];

        this.initializeExtensionUI();
        this.refreshMap();
    },

    zoomIn: function (e) {
        this.map.setZoom(this.map.getZoom() + 1);
    },

    zoomOut: function (e) {
        this.map.setZoom(this.map.getZoom() - 1);
    },

    zoomReset: function (e) {
        this.map.fitBounds(this.initialMapBounds);
    },

    initializeCustomization: function () {
        var self = this;

        var d = $.Deferred();

        this.customLayers = [];
        this.enabledLayers = [];

        this.layerConfig = {
            max_zoom_cluster: this.defaults.max_zoom_cluster,
            max_nr_subdevices: this.defaults.max_nr_subdevices,
            min_zoom: this.defaults.min_zoom,
            available: {},
        };

        this.popupConfig = ['#info', '@sub_devices'];

        $.getJSON('/api/v1/content/map_layers.json', function (spec) {
            self.popupConfig = spec.popup_config || self.popupConfig;

            spec.layers_config = spec.layers_config || self.layerConfig;
            self.layerConfig = {
                max_zoom_cluster: spec.layers_config.max_zoom_cluster || self.defaults.max_zoom_cluster,
                max_nr_subdevices: spec.layers_config.max_nr_subdevices || self.defaults.max_nr_subdevices,
                min_zoom: spec.layers_config.min_zoom || self.defaults.min_zoom,
                available: spec.layers_config.available || {},
            };

            self.extensionConf = {
                plugins: Array.isArray(spec.extension) ? spec.extension : [spec.extension],

                activeID: -1,
                activePlugin: undefined,
            };

            // remove all extensions that are not visible to current user
            self.extensionConf.plugins = _.filter(self.extensionConf.plugins, function (e) {
                if (e === undefined) {
                    return false;
                }
                if (
                    e.enabled_users !== undefined &&
                    e.enabled_users.length != 0 &&
                    _.indexOf(e.enabled_users, AppState.user.id) == -1
                ) {
                    return false;
                }
                return true;
            });

            if (self.extensionConf.plugins.length > 0) {
                self.initializeExtensionUI();
            }

            _.each(spec.layers, function (layer_spec) {
                var layerType = layer_spec.type || 'geojson';
                var layer = undefined;

                if (!AppState.hasCompanyDevicePermission() && layer_spec.admins_only) {
                    // protected layer - accessible only for company (device) admins
                    return;
                }

                switch (layerType) {
                    case 'geojson': {
                        layer = new L.GeoJSON.AJAX('/api/v1/content/' + layer_spec.data, {
                            style: layer_spec.style || {},
                            onEachFeature: function (feature, layer) {
                                if (feature.properties && layer_spec.popup) {
                                    var context = {
                                        name: layer_spec.popup.name,
                                        fields: [],
                                    };
                                    _.each(layer_spec.popup.fields, function (k) {
                                        context.fields.push({
                                            key: k,
                                            value: feature.properties[k],
                                        });
                                    });
                                    layer.bindPopup(CustomPopup(context));
                                }
                            },
                            pointToLayer: function (feature, latlng) {
                                return L.circleMarker(latlng);
                            },
                        });
                        break;
                    }
                    case 'shapefile': {
                        layer = L.tileLayer.wms('/api/v1/content_geo?', {
                            layers: layer_spec.data,
                            format: layer_spec.format,
                            transparent: true,
                        });
                        break;
                    }
                    case 'wms': {
                        // see: https://leafletjs.com/reference.html#tilelayer-wms
                        layer = L.tileLayer.wms(layer_spec.url, {
                            version: layer_spec.version || '1.1.1',
                            layers: layer_spec.data,
                            styles: layer_spec.styles || '',
                            format: layer_spec.format || 'image/jpeg',
                            transparent: layer_spec.transparent === true,
                            uppercase: layer_spec.uppercase === true,
                        });
                        break;
                    }
                }

                if (layer === undefined) {
                    Log.debug('invalid layerspecification');
                } else {
                    layer.min_zoom_level = layer_spec.min_zoom || 0;
                    layer.name = layer_spec.name;

                    self.customLayers.push(layer);
                    if (self.map.getZoom() > self.layerConfig.min_zoom) {
                        self.map.addLayer(layer);
                    }

                    self.layerConfig.available[layer.name] = layer;
                }
            });

            self.updateLayerControlVisibility();
            self.updateLayerControlStyling();

            self.map.on('zoomend', function (e) {
                self.updateLayerControlVisibility();
                self.pruneCluster.Cluster.Size = self.map.getZoom() > self.layerConfig.max_zoom_cluster ? -1 : 120;
                self.pruneCluster.ProcessView();
            });
            self.map.on('moveend', function (e) {
                if (!self.isRefreshing && AppState.featureBBoxMapReload) {
                    self.refreshMap(undefined, true);
                } else {
                    self.saveMapStateInURL();
                }
            });

            d.resolve(true);
        });

        return d.promise();
    },

    initializeDrawingToolbar: function () {
        // configure tooltips and other strings
        L.drawLocal.draw.toolbar.buttons.polygon = i18n.TR('Polygon-Auswahl');
        L.drawLocal.draw.toolbar.buttons.rectangle = i18n.TR('Rechteck-Auswahl');
        L.drawLocal.draw.toolbar.actions.title = i18n.TR('Auswahl abbrechen');
        L.drawLocal.draw.toolbar.actions.text = i18n.TR('Abbrechen');
        L.drawLocal.draw.toolbar.finish.title = i18n.TR('Auswahl abschließen');
        L.drawLocal.draw.toolbar.finish.text = i18n.TR('Auswählen');
        L.drawLocal.draw.toolbar.undo.title = i18n.TR('Letzten Punkt entfernen');
        L.drawLocal.draw.toolbar.undo.text = i18n.TR('Letzten Punkt entfernen');
        L.drawLocal.draw.handlers.rectangle.tooltip.start = i18n.TR('Klicken und ziehen zum Auswählen');
        L.drawLocal.draw.handlers.simpleshape.tooltip.end = i18n.TR('Loslassen zum Auswählen');
        L.drawLocal.draw.handlers.polygon.tooltip.start = i18n.TR('Klicken für ersten Punkt');
        L.drawLocal.draw.handlers.polygon.tooltip.cont = i18n.TR('Klicken für nächsten Punkt');
        L.drawLocal.draw.handlers.polygon.tooltip.end = i18n.TR('Ersten Punkt anklicken zum Auswählen');
        L.drawLocal.draw.handlers.polyline.error = i18n.TR('Keine Überschneidungen');

        // configure selection layer
        this.drawnItems = new L.FeatureGroup();
        this.map.addLayer(this.drawnItems);

        // configure selection controls
        this.drawControls = new L.Control.Draw({
            edit: false,
            draw: {
                featureGroup: this.drawnItems,
                marker: false,
                circlemarker: false,
                polyline: false,
                circle: false,

                polygon: {
                    allowIntersection: false,
                },
            },
        });
        this.map.addControl(this.drawControls);

        // selection handler
        var self = this;
        this.map.on(L.Draw.Event.CREATED, function (e) {
            // prepare selection area
            var poly = e.layer;
            var selectedIDs = [];

            _.each(self.pruneCluster.Cluster._markers, function (m) {
                if (poly.contains(m.position)) {
                    selectedIDs.push(m.data.id);
                }
            });

            if (selectedIDs.length > 1000) {
                // too many devices selected
                Notification.show(
                    'warning',
                    i18n.TR('Zu viele Geräte'),
                    i18n.TR('Bitte reduzieren Sie Ihre Auswahl.') + ' ' + i18n.TR('Maximum: 100.')
                );
                return;
            }

            if (selectedIDs.length > 0) {
                var pos = e.layer.getBounds().getCenter();
                self.map.setView(pos);

                // delayed execution prevents Firefox from immediately closing the popup
                setTimeout(function () {
                    var popup = L.popup({ closeButton: false }).setLatLng(pos).openOn(self.map);

                    // the popup code is dynamically inserted into the DOM
                    // -> so we have to do some "magic" to select the device

                    var getLink = function (text, categories, addBreak) {
                        return $(
                            '<h5' + (addBreak ? ' class="m-b-20"' : '') + '><a href="">' + text + '</a></h5>'
                        ).click(function (e) {
                            e.preventDefault();
                            popup.remove();

                            App.trigger(
                                'stats:dialog',
                                {
                                    filter: {
                                        map_devices: selectedIDs,
                                        category: categories,
                                        status: (self.filterObj || {}).status || [],
                                    },
                                    series: [],
                                    columnCategories: categories,
                                },
                                self.refreshMap.bind(self)
                            );
                        });
                    };

                    popup.setContent(
                        $('<center />')
                            .append(getLink(i18n.TR('Alle Geräte'), undefined, true))
                            .append(getLink(i18n.TR('Nur Gateways'), ['Gateway', 'FakeGateway']))
                            .append(getLink(i18n.TR('Nur Regler'), ['55xx56xx']))
                            .append(getLink(i18n.TR('Nur Zähler'), ['Meter', 'FakeMeter']))[0]
                    );
                    $('.leaflet-popup-tip-container').addClass('hidden');
                }, 250);
            }
        });
    },

    initializePopupHandler: function () {
        var self = this;

        this.map.on('zoomstart', function () {
            self.map.closePopup();
        });
        this.map.on('popupopen', function (e) {
            var popup = $('.js-popup-content')[0];
            if (popup == undefined) {
                // -> not a device info popup
                return;
            }

            var deviceID = popup.id;

            // determine required backend infos
            var needMiscInfos = false;
            var needSubDeviceList = false;

            _.each(self.popupConfig, function (item) {
                needMiscInfos = needMiscInfos || (!item.startsWith('#') && !item.startsWith('@'));
                needSubDeviceList = needSubDeviceList || item == '@sub_devices';
            });

            // configure tasks to fetch required backend infos
            var notRequired = function () {
                var defer = $.Deferred();
                defer.resolve(undefined);
                return defer.promise();
            };

            var background = Misc.getBackgroundTaskManager();
            var tasks = [App.request('device:model', deviceID)];

            tasks.push(needMiscInfos ? App.request('miscinfo:model', deviceID) : notRequired());
            tasks.push(
                needSubDeviceList
                    ? App.request('device:list', {
                          filterParams: {
                              parentID: deviceID,
                              limit: self.layerConfig.max_nr_subdevices + 1,
                          },
                      })
                    : notRequired()
            );

            tasks.push(App.request('device:values', deviceID));

            // fetch infos
            background.whenArray(tasks).done(function (device, misc, subdevices, values) {
                if (device === undefined) {
                    // could not even fetch device -> do nothing
                    return;
                }

                var miscInfo = {};
                if (misc != undefined) {
                    _.each(misc.attributes.fields, function (f) {
                        miscInfo[f.name] = f.value;
                    });
                }

                var subdeviceInfo = undefined;
                if (subdevices != undefined && subdevices.count > 0) {
                    subdeviceInfo = {
                        list: subdevices.items.toJSON().slice(0, self.layerConfig.max_nr_subdevices),
                        tooMany: subdevices.count > self.layerConfig.max_nr_subdevices,
                    };
                }

                var formattedData = _.mapObject(device.attributes.data || {}, function (value, key) {
                    var formatInfo = _.filter(values.models, function (v) {
                        return v.attributes['type'] + '_' + v.attributes['nr'] == key;
                    });
                    if (formatInfo.length == 0) {
                        return;
                    }

                    var data = Misc.formatValueUnitBySpec(value, key, formatInfo[0].attributes);
                    data.name = formatInfo[0].attributes.name;

                    return data;
                });

                var context = {
                    device: device.attributes || {},
                    link: Misc.getDeviceURL(device.get('category'), device.id),

                    popup_config: self.popupConfig,

                    data: formattedData,

                    misc: miscInfo,
                    subdevices: subdeviceInfo,
                };

                e.popup.setContent(MarkerContent(context));
            });
        });
    },

    onAttach: function () {
        // TODO: integrate in JS build process
        // load map files
        Misc.loadAdditionalFile('css/vendor/map_combined.css', 'css');
        Misc.loadAdditionalFile('map_combined.js', 'js');
        Misc.loadAdditionalFile('/api/v1/content/map_extension.js', 'js');

        var self = this;
        // initialize map
        setTimeout(function () {
            maplibregl.workerCount = 2;
            maplibregl.maxParallelImageRequests = 2;

            if (!self.isDestroyed) {
                self.initializeMap();
            }
        }, 2000);
        this.showFilterView();
        this.showToolbarView();
    },

    onBeforeDestroy: function () {
        // remove resize handler
        var handlerFuncIndex = window.resizefunc.indexOf('mapResizeHandler');
        if (handlerFuncIndex != -1) {
            window.resizefunc.splice(handlerFuncIndex, 1);
            window.mapResizeHandler = undefined;
        }
    },

    onDestroy: function () {
        AppState.clearURLParameterCache();

        if (window.map_extension !== undefined && typeof window.map_extension.destroy === 'function') {
            // destroy map extension plugin
            window.map_extension.destroy();
        }
    },
});

module.exports = MapView;
